import { render } from "./rulesPage.vue?vue&type=template&id=53d20344&scoped=true"
import script from "./rulesPage.vue?vue&type=script&lang=js"
export * from "./rulesPage.vue?vue&type=script&lang=js"

import "./rulesPage.vue?vue&type=style&index=0&id=53d20344&lang=scss&scoped=true"

import exportComponent from "/Users/johnhan/Desktop/project/huitu_activity_fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d20344"]])

export default __exports__